const PRIMARY_PRIORITY_FOLDERS = new Set([
  'ohne',
  'XLquer',
  'XLQuer', // Auch bereits gespeicherte Prioritäten mit großem Q korrigieren.
  'XLquerK29',
  'XLhoch',
  'XLhochK29',
  'KK',
  'KS',
  'KW',
]);

const XL_HOCH_K29_MIN_DIMENSION = 1500;
const PG400_450_KAEMPFER_LINKS_STEPS = new Set([561, 583, 606, 632, 652, 679]);
const SLIDING_DIRECTION_FOLDERS = new Set([
  'links_nach_rechts',
  'rechts_nach_links',
  'unten_nach_oben',
  'oben_nach_unten',
]);

export const getKaempferLinksXLFolder = stepId => (
  PG400_450_KAEMPFER_LINKS_STEPS.has(Number(stepId)) ? 'XLquer' : 'XLquerK29'
);

export const getSlidingDirectionFolder = value => {
  const folder = String(value ?? '').trim().toLowerCase().replace(/^fld:/, '').replace(/\s+/g, '_');
  return SLIDING_DIRECTION_FOLDERS.has(folder) ? folder : '';
};

export const replaceSlidingDirectionFolder = (priorityFolders, direction) => {
  if (!direction) return priorityFolders;

  const parts = String(priorityFolders || '')
    .split(',')
    .map(part => part.trim())
    .filter(part => part && part !== 'ohne' && !SLIDING_DIRECTION_FOLDERS.has(part));

  return Array.from(new Set([...parts, direction])).join(',');
};

const toDimensionNumber = value => {
  const normalized = String(value ?? '').trim().replace(',', '.');
  if (normalized === '') return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const shouldUseXLhochK29 = (width, height, hasXLProfile) => {
  if (!hasXLProfile) return false;

  const parsedWidth = toDimensionNumber(width);
  const parsedHeight = toDimensionNumber(height);

  return parsedWidth !== null
    && parsedHeight !== null
    && parsedWidth >= XL_HOCH_K29_MIN_DIMENSION
    && parsedHeight >= XL_HOCH_K29_MIN_DIMENSION;
};

export const getConfiguredDimensions = (items = []) => {
  for (const item of items || []) {
    const value = String(item?.value ?? item?.emptyValue ?? '');
    const match = value.match(/(-?\d+(?:[.,]\d+)?)\s*(?:mm)?\s*x\s*(-?\d+(?:[.,]\d+)?)/i);
    if (match) {
      return { width: match[1], height: match[2] };
    }
  }

  return { width: null, height: null };
};

export const replacePrimaryPriorityFolder = (priorityFolders, nextPrimary) => {
  const parts = String(priorityFolders || '')
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

  if (parts.length > 0 && PRIMARY_PRIORITY_FOLDERS.has(parts[0])) {
    parts[0] = nextPrimary;
  } else {
    parts.unshift(nextPrimary);
  }

  return Array.from(new Set(parts)).join(',');
};
